import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    coverType: 'Тип обложки',
    type1: 'Тип 1',
    type2: 'Тип 2',
    header: 'Шапка',
    card: 'Карточка',
    gradient: 'Градиент',
    statusLoadFailed: 'Не удалось загрузить статус публикации',
    retry: 'Повторить',
    articleAccess: 'Доступ к статье',
    saveToPublish: 'Сохраните статью, чтобы опубликовать',
    saveChangesFirst: 'Дождитесь сохранения изменений',
    catalogSection: 'Раздел каталога',
    articleLink: 'Ссылка на инструкцию',
    linkCopied: 'Ссылка скопирована',
    deleteInstruction: 'Удалить инструкцию',
  },
  en: {
    coverType: 'Cover type',
    type1: 'Type 1',
    type2: 'Type 2',
    header: 'Header',
    card: 'Card',
    gradient: 'Gradient',
    statusLoadFailed: 'Couldn’t load the publishing status',
    retry: 'Retry',
    articleAccess: 'Article access',
    saveToPublish: 'Save the article to publish it',
    saveChangesFirst: 'Wait for your changes to save',
    catalogSection: 'Catalog section',
    articleLink: 'Article link',
    linkCopied: 'Link copied',
    deleteInstruction: 'Delete article',
  },
})
